// WithRestaurantProvider.jsx
import {useNavigate, useParams} from "react-router";
import {AppProvider, useApp} from "../Context";
import {useEffect} from "react";

const WithRestaurantProvider = ({ children }) => {
  const { restaurant } = useParams();

  return (
    <AppProvider restaurant={restaurant}>
      {children}
    </AppProvider>
  );
};

export default WithRestaurantProvider;
